import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  RemoveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {EmojiListProps} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/EmojiList'
import {useEditSidebarItem} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem'
import Settings from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/EmojiList/EmojiListConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import {Rule} from 'Event/attendee-rules'

export function EmojiListConfig(
  props: ComponentConfigProps & {
    list: EmojiListProps
  },
) {
  const {showing, onClose} = props
  const {list} = props
  const [emojiWidth, setEmojiWidth] = useState(list.emojiWidth)
  const [emojis, setEmojis] = useState(list.emojis)
  const {removeList, update: updateItem} = useEditSidebarItem()
  const [rules, setRules] = useState<Rule[]>(list.rules || [])

  const {control, setValue} = useForm()

  useEffect(() => {
    if (showing) {
      return
    }

    setEmojiWidth(list.emojiWidth)
    setEmojis(list.emojis)
  }, [showing, list])

  const save = () => {
    const data = {
      emojiWidth,
      emojis,
      rules,
    }

    updateItem(data)
    onClose()
  }

  return (
    <ComponentConfig title="Emojis" showing={showing} onClose={onClose}>
      <SettingsPanel>
        <Settings
          emojiWidth={emojiWidth}
          setEmojiWidth={setEmojiWidth}
          emojis={emojis}
          setEmojis={setEmojis}
        />
      </SettingsPanel>
      <RulesPanel rules={rules} setRules={setRules}>
        <ScheduleInput setValue={setValue} control={control} values={list} />
      </RulesPanel>
      <Footer>
        <SaveButton onClick={save} />
        <RemoveButton onClick={() => removeList([])} />
      </Footer>
    </ComponentConfig>
  )
}
